module.exports = [
	{
		"key"  : "analytic",
		"text" : "analytics",
		"img"  : "",
		"icon" : "mdi-vector-square"

	},
	{
		"key"  : "lpr",
		"text" : "plates",
		"img"  : "/img/tags/lpr/",
		"icon" : "mdi-card-bulleted", // relative-scal",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "car",
		"text" : "car",
		"img"  : "/img/tags/car/",
		"icon" : "mdi-car-multiple",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "person",
		"text" : "person",
		"img"  : "/img/tags/person/",
		"icon" : "mdi-account-group",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "gun",
		"text" : "gun",
		"img"  : "/img/tags/gun/",
		"icon" : "mdi-pistol",
		"color" : "error",
		"is_tag" : true,
	},
	{
		"key"  : "hands_up",
		"text" : "hands_up",
		"img"  : "/img/tags/hands_up/",
		"icon" : "mdi-human-handsup",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "laptop",
		"text" : "laptop",
		"img"  : "/img/tags/laptop/",
		"icon" : "mdi-laptop",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "truck",
		"text" : "truck",
		"img"  : "/img/tags/truck/",
		"icon" : "mdi-truck",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "bike",
		"text" : "bike",
		"img"  : "/img/tags/",
		"icon" : "mdi-bike",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "motorbyke",
		"text" : "motorbyke",
		"img"  : "/img/tags/motorcycle/",
		"icon" : "mdi-motorbike",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "motorcycle",
		"text" : "motorcycle",
		"img"  : "/img/tags/motorcycle/",
		"icon" : "mdi-motorbike",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "bus",
		"text" : "bus",
		"img"  : "/img/tags/bus/",
		"icon" : "mdi-bus-side",
		"color" : "primary",
		"is_tag" : true,
	},				
	{
		"key"  : "face",
		"text" : "face",
		"img"  : "/img/tags/face/",
		"icon" : "mdi-face-recognition",
		"color" : "primary",
		"is_tag" : true,
	},
	//  /
	{
		"key"  : "anomalies",
		"text" : "anomalies",
		"img"  : "/img/tags/",
		"icon" : "mdi-panorama-horizontal",
		"color" : "warning"
	},
	{
		"key"  : "walking",
		"text" : "walking",
		"img"  : "/img/tags/walking/",
		"icon" : "mdi-walk",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "fighting",
		"text" : "fighting",
		"img"  : "/img/tags/fighting/",
		"icon" : "mdi-fencing",
		"color" : "error",
		"is_tag" : true,
	},
	{
		"key"  : "calling",
		"text" : "calling",
		"img"  : "/img/tags/calling/",
		"icon" : "mdi-phone-in-talk",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "falling",
		"text" : "falling",
		"img"  : "/img/tags/falling/",
		"icon" : "mdi-slope-downhill",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "sitting",
		"text" : "sitting",
		"img"  : "/img/tags/sitting/",
		"icon" : "mdi-human-wheelchair",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "standing",
		"text" : "standing",
		"img"  : "/img/tags/standing/",
		"icon" : "mdi-human-male",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "motion",
		"text" : "motion",
		"img"  : "/img/tags/motion/",
		"icon" : "mdi-image-multiple", // image-size-select-large / image-filter-center-focus-stron",					
		"color" : "primary"
	},
	{
		"key"  : "alert",
		"text" : "alert",
		"img"  : "/img/tags/alert/",
		"icon" : "mdi-alert", // image-size-select-large / image-filter-center-focus-stron",					
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "success",
		"text" : "success",
		"img"  : "/img/tags/success/",
		"icon" : "mdi-check", // image-size-select-large / image-filter-center-focus-stron",					
		"color" : "primary"
	},
	{
		"key"  : "normal",
		"text" : "normal",
		"img"  : "/img/tags/normal/",
		"icon" : "mdi-squad", // image-size-select-large / image-filter-center-focus-stron",					
		"color" : "primary"
	},
	{
		"key"  : "warning",
		"text" : "warning",
		"img"  : "/img/tags/warning/",
		"icon" : "mdi-warning", // image-size-select-large / image-filter-center-focus-stron",					
		"color" : "primary"
	},				
	{
		"key"  : "smart_event",
		"text" : "smart_event",
		"img"  : "",
		"icon" : "mdi-gesture-tap-button",
		"color" : "primary"
	},
	{
		"key"  : "knife",
		"text" : "knife",
		"img"  : "", // /img/tags/knife/
		"icon" : "mdi-knife-military",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "avc",
		"text" : "avc",
		"img"  : "",
		"icon" : "mdi-axis",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "data",
		"text" : "data",
		"img"  : "",
		"icon" : "mdi-counter",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "aeroplane",
		"text" : "aeroplane",
		"img"  : "/img/tags/aeroplane/",
		"icon" : "mdi-airplane",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "fire",
		"text" : "fire",
		"img"  : "",
		"icon" : "mdi-fire",
		"color" : "error",
		"is_tag" : true,
	},
	{
		"key"  : "helmet",
		"text" : "helmet",
		"img"  : "",
		"icon" : "mdi-sheep",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "no_helmet",
		"text" : "no_helmet",
		"img"  : "",
		"icon" : "mdi-sheep",
		"color" : "primary",
		"is_tag" : true,
	},
	{
		"key"  : "box",
		"text" : "box",
		"img"  : "",
		"icon" : "mdi-box-shadow",
		"color" : "primary",
		"is_tag" : true,
	},
];